/**
 * The task tours this build carries (SA-1316 spec §7): `content/help/taskTours.json`, written by
 * `npm run docs:corpus`. An answer names a tour by id; an id this bundle lacks is no tour.
 */
import data from '@/content/help/taskTours.json'
import type { TaskTour } from './taskTour'

const TOURS = new Map((data as { tours: TaskTour[] }).tours.map((t) => [t.id, t]))

export function taskTourById(id: string | null | undefined): TaskTour | null {
  return (id && TOURS.get(id)) || null
}

/** Whether the viewer may open every page the tour visits: each route's features and permissions. */
export function mayPlay(tour: TaskTour, features: ReadonlySet<string>, permissions: ReadonlySet<string>): boolean {
  return tour.routes.every((r) => r.features.every((f) => features.has(f)) && r.permissions.every((p) => permissions.has(p)))
}
